import { render, staticRenderFns } from "./inviteVIP.vue?vue&type=template&id=6d9501f6&"
import script from "./inviteVIP.vue?vue&type=script&lang=js&"
export * from "./inviteVIP.vue?vue&type=script&lang=js&"
import style0 from "./inviteVIP.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports